import store from '@/store'
import unmask from '@/utils/unmask'
import { repositoryFactory } from '@/repositories/repositoryFactory'

const repository = repositoryFactory.get('conectaSus.cadastro.localizacao.logradouro')

export default {
    validate: async cep => {

        store.commit('setLoading')

        const hasCep = (await repository.hasCep(unmask.unMaskCep(cep))).data

        store.commit('unsetLoading')

        if (!hasCep) {

            return 'CEP não cadastrado no sistema.'
        }

        return true
    },
}